export default "__VITE_ASSET__Dr3pMJOo__"